/*
 * @Descripttion: 
 * @version: v0.0.1
 * @Author: ZhouYanPing
 * @Date: 2021-06-04 13:40:37
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-06-04 13:45:13
 */

import React from 'react';

class Notice extends React.Component {
  render() {
    return <div>
      {this.props.children}
    </div>
  }
};
export default Notice;



// WEBPACK FOOTER //
// ./src/routes/rebateBillManage/index.js